// extracted by mini-css-extract-plugin
module.exports = {"container":"credit-title_container__2ET4P","title":"credit-title_title__4scDY","subtitle":"credit-title_subtitle__1ITcj","isSubtitle":"credit-title_isSubtitle__3cQee"};